import React from "react";
import { getColor, getDarkTextColor, getTextColor } from "../../common/ThemeService";

const OptionButtons = (props) => {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    const themeDarkTextColor = getDarkTextColor()
    return (<div className="optionButton_wrapper">
        <style>
            {`
                div.optionButton:hover {\
                    background-color: ${themeColor};\
                    color: ${themeTextColor} !important;\
                }\
                div.optionButton_disabled:hover {
                    background-color: #FFFFFF;
                    color: grey !important;\
                }
            `}
        </style>
        {props.buttonArray.map((buttonObj, i) => {
            return !buttonObj.isVisbile && <div key={i}
            data-e2e={buttonObj.datae2e}
                className={" optionButton " + (buttonObj.disabled ? "optionButton_disabled" : "")}
                style={buttonObj.disabled ? { } : {
                    color: themeDarkTextColor,
                    borderColor: themeColor,
                }}
                onClick={() => {
                    if (!buttonObj.disabled && buttonObj.onclickMethod) {
                        buttonObj.onclickMethod();
                    }
                }} {...buttonObj.props} >
                {buttonObj.name}
            </div>
        })}
    </div>)
}

export default OptionButtons;


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/OptionButtons.js
 **/